var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trial-container"},[_c('div',{staticClass:"acdsx"},[_c('p',[_vm._v("网站正在升级维护中，可点击下方按钮进行试用！")]),_c('div',{staticClass:"clickfree",on:{"click":_vm.gommsy}},[_vm._v("点击试用")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }